// import MiniStatistics from "./components/MiniStatistics";
// import FakeBarChart from "assets/img/account/FakeBarChart.png";

import {
    // MdOutlineBarChart,
    // MdPerson,
    // MdFileCopy,
    MdClose,
    MdCheck,
    // MdLoop,
    // MdMarkEmailUnread,
    MdOutlineMarkEmailUnread, MdOutlineViewList,
    // MdPeople, MdAccessibilityNew,
    MdListAlt, MdOutlineLoop
} from "react-icons/md";
import ManagementTable from "./components/ManagementTable";
import {tableColumnsManagement} from "views/admin/feedback/variables/tableColumnsManagement";
// import tableDataManagement from "views/admin/feedback/variables/tableDataManagement.json";
// import Widget from "../../../components/widget/Widget";
// import {IoShieldCheckmark} from "react-icons/io5";
import React, {useEffect, useState} from "react";
import Widget3 from "../../../components/widget/Widget3";
import {useUserAuth} from "../../../context/UserAuthContext";
import {AES, enc} from "crypto-js";
import {useNavigate} from "react-router-dom";
import useAsyncEffect from "use-async-effect";
import axios from "axios";
import ClipLoader from "react-spinners/ClipLoader";
import moment from "moment";
import Course from "components/card/Course";

const Feedback = () => {

    var sv = "";

    const CROMPTON_URL = process.env.REACT_APP_CROMPTON_SENZE_URL;
    const CROMPTON_ANALYTICS_URL = process.env.REACT_APP_CROMPTON_SENZE_ANALYTICS_URL;

    //const CROMPTON_URL = "https://iot.crompton.co.in:8443/PAPI/"
    //const CROMPTON_ANALYTICS_URL = "https://iot.crompton.co.in:8443/AAPI/"
    const secretKey = "cromptonssecretkey";

    let {Token, logOut, Username, accesscontrollevel} = useUserAuth();
    const decryptedValue = AES.decrypt(Token, secretKey).toString(enc.Utf8);

    const [totalFeedbackValues, setTotalFeedbackValues] = useState(0);
    const [openFeedbackValues, setOpenFeedbackValues] = useState(0);
    const [ongoingFeedbackValues, setOngoingFeedbackValues] = useState(0);
    const [closedFeedbackValues, setClosedFeedbackValues] = useState(0);

    const [allFeedbacks, setAllFeedbacks] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const [filteredFeedbacks, setFilteredFeedbacks] = useState([]);
    const [selectedFeedback, setSelectedFeedback] = useState(null);
    const [selectedFilter, setSelectedFilter] = useState("OPEN");
    let [transformedData, setTransformedData] = useState([]);

    useEffect(() => {
        if (!selectedFeedback) return undefined;

        const previousOverflow = document.body.style.overflow;
        const closeOnEscape = (event) => {
            if (event.key === "Escape") setSelectedFeedback(null);
        };

        document.body.style.overflow = "hidden";
        document.addEventListener("keydown", closeOnEscape);
        return () => {
            document.body.style.overflow = previousOverflow;
            document.removeEventListener("keydown", closeOnEscape);
        };
    }, [selectedFeedback]);

    // 👇 filter logic
    /*const applyFilter = (filter) => {
        setSelectedFilter(filter);
        if (filter === "ALL") {
            setFilteredFeedbacks(allFeedbacks);
        } else if (filter === "OPEN") {
            setFilteredFeedbacks(allFeedbacks.filter(fb => fb.status === "OPEN"));
        } else if (filter === "ONGOING") {
            setFilteredFeedbacks(allFeedbacks.filter(fb => fb.status === "ONGOING"));
        } else if (filter === "CLOSED") {
            setFilteredFeedbacks(allFeedbacks.filter(fb => fb.status === "CLOSED"));
        }
    };*/

    const getStatusLabel = (status) => {
        switch (status) {
            case 0:
                return "OPEN";
            case 1:
                return "ONGOING";
            case 2:
                return "CLOSED";
            default:
                return "UNKNOWN";
        }
    };

    const applyFilter = (filter) => {
        setIsLoading(true);
        setSelectedFilter(filter);

        if (filter === "ALL") {
            setTransformedData(allFeedbacks);
            setFilteredFeedbacks(allFeedbacks)
        } else {
            setTransformedData(
                allFeedbacks.filter(fb => getStatusLabel(fb.status) === filter)
            );
            setFilteredFeedbacks(
                allFeedbacks.filter(fb => getStatusLabel(fb.status) === filter)
            );
        }

        setIsLoading(false);
    };

    const navigate = useNavigate();

    const getDaysInMonth = (year, month) => new Date(year, month, 0).getDate()

    const addMonths = (input, months) => {
        const date = new Date(input)
        date.setDate(1)
        date.setMonth(date.getMonth() + months)
        date.setDate(Math.min(input.getDate(), getDaysInMonth(date.getFullYear(), date.getMonth() + 1)))
        return date.toISOString().slice(0, 10)
    }

    const [LowerDate, setLowerDate] = useState(addMonths(new Date(new Date().toISOString().slice(0, 10)), -5));
    const [UpperDate, setUpperDate] = useState(new Date().toISOString().slice(0, 10));

    const [message, setErrorMessage] = useState("");


    const normalize = (status) => {
        if (typeof status !== "string") return "";
        return status.trim().toUpperCase();
    };

    const handleLogOut = async () => {
        try {
            await logOut();
            navigate("/");
        } catch (error) {
            ////console.log(error.message);
        }
    }

    const handleIncreaseDate = (currentDate) => {
        const newDate = moment(currentDate, 'DD-MM-YYYY').add(1, 'days');
        currentDate = newDate.format('DD-MM-YYYY')
        //console.log("CURRENT DATE: ", currentDate)
        return currentDate
    };

    function formatDateForApi(date) {
        var d = date.split("-");
        var y = d[0]
        var m = d[1]
        var da = d[2]
        date = da + "-" + m + "-" + y
        ////console.log(date)
        return date
    }

    async function getAllFeedbacks() {
        if (accesscontrollevel.toString() === "1" || accesscontrollevel.toString() === "4") {
            var url =
                CROMPTON_ANALYTICS_URL +
                "v1/user/feedbacks/getAll/" +
                formatDateForApi(LowerDate) +
                "/" +
                handleIncreaseDate(formatDateForApi(UpperDate));

            //console.log(url);

            await axios({
                method: "GET",
                url: url,
                headers: {
                    Authorization: decryptedValue,
                },
            })
                .then((res) => {
                    //console.log(res);

                    /*// ✅ use res.data instead of filteredFeedbacks
                    let tData = res.data.map((item) => {
                        const [category, user] = (item.category || "").split(" : ");
                        return {
                            ...item,
                            categoryOnly: category, // new field
                            userOnly: user || "", // new field
                        };
                    });*/

                    let tData = res.data.map((item) => {
                        const value = item.category || "";
                        const separator = " - ";
                        const lastSeparatorIndex = value.lastIndexOf(separator);

                        let categoryOnly = value;
                        let userOnly = "";

                        if (lastSeparatorIndex !== -1) {
                            categoryOnly = value.substring(0, lastSeparatorIndex).trim();
                            userOnly = value.substring(lastSeparatorIndex + separator.length).trim();
                        }

                        return {
                            ...item,
                            categoryOnly,
                            userOnly,
                        };
                    });

                    setAllFeedbacks(tData);
                    //setFilteredFeedbacks(tData); // default show all
                    //setTransformedData(tData);

                    const openList = tData.filter((fb) => getStatusLabel(fb.status) === "OPEN");
                    const ongoingList = tData.filter((fb) => getStatusLabel(fb.status) === "ONGOING");
                    const closedList = tData.filter((fb) => getStatusLabel(fb.status) === "CLOSED");

                    setTotalFeedbackValues(tData.length);
                    setOpenFeedbackValues(openList.length);
                    setOngoingFeedbackValues(ongoingList.length);
                    setClosedFeedbackValues(closedList.length);

                    //setIsLoading(false);
                })
                .catch((error) => {
                    setIsLoading(false);
                    setErrorMessage(error.response.data.message);
                    if (
                        error.response.data.status === "401" ||
                        error.response.data.status === "403"
                    ) {
                        handleLogOut();
                    }
                });
        } else {
            setIsLoading(false);
            setErrorMessage(
                "You do not have permission to view this. Please contact admin."
            );
        }
    }


    useAsyncEffect(async () => {
        setIsLoading(true)

        async function getOverallFeedbackSummary() {
            if ((accesscontrollevel.toString() === "1")) {
                var url = CROMPTON_ANALYTICS_URL + "v1/user/feedbacksMonthly/" + formatDateForApi(LowerDate) + "/" + formatDateForApi(UpperDate)

                await axios({
                    method: "GET", url: url, headers: {
                        Authorization: decryptedValue,
                    }

                }).then((res) => {

                    //console.log(res.data)
                    let open = 0;
                    let closed = 0;
                    let ongoing = 0;
                    let total = 0;
                    setErrorMessage("")
                    for (const i in res.data) {
                        if (i < (Object.keys(res.data).length - 1)) {
                            open = open + res.data[i].open;
                            ongoing = ongoing + res.data[i].ongoing;
                            closed = closed + res.data[i].closed;

                            /*console.log(open)
                            console.log(ongoing)
                            console.log(closed)*/
                        }
                    }

                    total = open + closed + ongoing
                    setTotalFeedbackValues(total)
                    setOpenFeedbackValues(open)
                    setClosedFeedbackValues(closed)
                    setOngoingFeedbackValues(ongoing)

                    setIsLoading(false)

                    //getAllFeedbacks()

                    /*console.log("Data labels: ", chartLabels)
                    console.log("Data values: ", count)*/

                }).catch((error) => {
                    setErrorMessage(error.response.data.message)
                    setIsLoading(false)
                    if (error.response.data.status === "401" || error.response.data.status === "403") {
                        handleLogOut();
                    }
                })

            } else {
                //console.log("Inside stats non admin")
                setIsLoading(false)
                setErrorMessage("You do not have permission to view this. Please contact admin.")
            }

        }

        await getOverallFeedbackSummary()
        await getAllFeedbacks()

    }, [sv]);

    // ✅ Separate useEffect for applying filter after data loads
    useEffect(() => {
        if (allFeedbacks.length > 0) {
            applyFilter("OPEN");
        }
    }, [allFeedbacks]);

    return (
        isLoading === true ? (
                <div className="flex justify-center items-center h-64">
                    <ClipLoader color="#2563eb" size={50}/>
                </div>
            )
            :
            (<>
                <div className="mt-3 h-full w-full rounded-[20px]">
                    <div
                        className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4 2xl:grid-cols-4 3xl:grid-cols-4">
                        {/* Total Feedback */}
                        <div
                            onClick={() => applyFilter("ALL")}
                            className={`cursor-pointer rounded-2xl transition duration-200
            ${selectedFilter === "ALL" ? "bg-blue-100 border-2 border-[#004c86]" : "hover:bg-gray-100"}`}
                        >
                            <Widget3
                                icon={<MdListAlt className="h-6 w-6 text-[#004c86]"/>}
                                title={"Total Feedback"}
                                subtitle={totalFeedbackValues}
                            />
                        </div>

                        {/* Open Feedback */}
                        <div
                            onClick={() => applyFilter("OPEN")}
                            className={`cursor-pointer rounded-2xl transition duration-200
            ${selectedFilter === "OPEN" ? "bg-green-100 border-2 border-green-600" : "hover:bg-gray-100"}`}
                        >
                            <Widget3
                                icon={<MdOutlineMarkEmailUnread className="h-7 w-7 text-[#004c86]"/>}
                                title={"Open Feedback"}
                                subtitle={openFeedbackValues}
                            />
                        </div>

                        {/* Ongoing Feedback */}
                        <div
                            onClick={() => applyFilter("ONGOING")}
                            className={`cursor-pointer rounded-2xl transition duration-200
            ${selectedFilter === "ONGOING" ? "bg-yellow-100 border-2 border-yellow-600" : "hover:bg-gray-100"}`}
                        >
                            <Widget3
                                icon={<MdOutlineLoop className="h-6 w-6 text-[#004c86]"/>}
                                title={"Ongoing Feedback"}
                                subtitle={ongoingFeedbackValues}
                            />
                        </div>

                        {/* Closed Feedback */}
                        <div
                            onClick={() => applyFilter("CLOSED")}
                            className={`cursor-pointer rounded-2xl transition duration-200
            ${selectedFilter === "CLOSED" ? "bg-red-100 border-2 border-red-600" : "hover:bg-gray-100"}`}
                        >
                            <Widget3
                                icon={<MdCheck className="h-6 w-6 text-[#004c86]"/>}
                                title={"Closed Feedback"}
                                subtitle={closedFeedbackValues}
                            />
                        </div>
                    </div>
                    <div className="mt-3">
                        <ManagementTable
                            tableData={transformedData}
                            columnsData={tableColumnsManagement}
                            onRowClick={setSelectedFeedback}
                        />
                    </div>
                </div>
                {selectedFeedback && (
                    <div
                        className="fixed inset-0 z-[9999] flex items-center justify-center bg-navy-900/70 p-4 backdrop-blur-sm"
                        onMouseDown={(event) => {
                            if (event.target === event.currentTarget) setSelectedFeedback(null);
                        }}
                    >
                        <div role="dialog" aria-modal="true" aria-label="Feedback details" className="relative max-h-[92vh] w-full max-w-5xl overflow-y-auto rounded-[24px] bg-white p-2 shadow-2xl dark:bg-navy-800">
                            <div className="sticky top-0 z-20 flex items-center justify-between rounded-t-[20px] border-b border-gray-200 bg-white/95 px-5 py-4 backdrop-blur dark:border-white/10 dark:bg-navy-800/95">
                                <div>
                                    <p className="text-xs font-semibold uppercase tracking-[0.16em] text-[#004c86]">Feedback details</p>
                                    <h2 className="mt-1 text-xl font-bold text-navy-700 dark:text-white">Review and respond</h2>
                                </div>
                                <button type="button" onClick={() => setSelectedFeedback(null)} aria-label="Close feedback details" className="flex h-10 w-10 items-center justify-center rounded-full bg-gray-100 text-xl text-gray-600 transition hover:bg-gray-200 dark:bg-navy-700 dark:text-white">
                                    <MdClose/>
                                </button>
                            </div>
                            <Course
                                extra="!rounded-t-none !shadow-none"
                                icon={selectedFeedback.url || <MdOutlineViewList/>}
                                title={`${selectedFeedback.category || selectedFeedback.categoryOnly || "Feedback"} -> ${selectedFeedback.subCategory || "General"} (V:${selectedFeedback.appVer || "NA"})`}
                                desc={selectedFeedback.feedback}
                                day={selectedFeedback.createdTime ? new Date(selectedFeedback.createdTime).toLocaleString("en-IN", {timeZone: "Asia/Kolkata"}) : "Not available"}
                                date={selectedFeedback.lastModified ? new Date(selectedFeedback.lastModified).toLocaleString("en-IN", {timeZone: "Asia/Kolkata"}) : "Not available"}
                                deviceAddress={selectedFeedback?.deviceInfo?.deviceAddress || selectedFeedback.deviceAddress || ""}
                                productId={selectedFeedback?.deviceInfo?.productId || selectedFeedback.productId || ""}
                                data={selectedFeedback}
                                fid={selectedFeedback.id}
                            />
                        </div>
                    </div>
                )}
            </>
            )
    );
};

export default Feedback;
